//@ts-nocheck
import {Column} from 'react-table'
import {HistoryLogName} from './HistoryLogName'
import {HistoryDescription} from './HistoryDescription'
import {HistorySubjectId} from './HistorySubjectId'
import {HistoryCauserId} from './HistoryCauserId'
//import {HistorySelectionCell} from './HistorySelectionCell'
import {HistoryCustomHeader} from './HistoryCustomHeader'
//import {HistorySelectionHeader} from './HistorySelectionHeader'
import {History} from '../../core/_models'

const HistoryColumns: ReadonlyArray<Column<History>> = [
  {
    Header: (props) => (
      <HistoryCustomHeader tableProps={props} title='LOG_NAME' className='min-w-125px' />
    ),
    id: 'log_name',
    Cell: ({...props}) => <HistoryLogName history={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <HistoryCustomHeader
        tableProps={props}
        title='COMMON.DESCRIPTION'
        className='min-w-125px'
      />
    ),
    id: 'description',
    Cell: ({...props}) => <HistoryDescription history={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <HistoryCustomHeader tableProps={props} title='LOG_SUBJECT_ID' className='min-w-125px' />
    ),
    id: 'subject_id',
    Cell: ({...props}) => <HistorySubjectId history={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <HistoryCustomHeader tableProps={props} title='LOGS.CAUSER_ID' className='min-w-125px' />
    ),
    id: 'causer_id',
    Cell: ({...props}) => <HistoryCauserId history={props.data[props.row.index]} />,
  },
]

export {HistoryColumns}
